module.exports = __webpack_public_path__ + "static/media/uploadSVG.d1228406.svg";